import { RunTabKey } from './runTabs'

export const clampPages = (pages: Record<RunTabKey, number>, totalPagesByKey: Record<RunTabKey, number>): Record<RunTabKey, number> => {
  let changed = false
  const next = { ...pages }
  for (const key of Object.keys(pages) as RunTabKey[]) {
    const totalPages = totalPagesByKey[key]
    if (totalPages <= 0) continue
    const clamped = Math.min(pages[key], Math.max(0, totalPages - 1))
    if (clamped !== pages[key]) {
      next[key] = clamped
      changed = true
    }
  }
  return changed ? next : pages
}
